import { render, staticRenderFns } from "./ModalAplicacao.vue?vue&type=template&id=2dbe5811&scoped=true"
import script from "./ModalAplicacao.vue?vue&type=script&lang=js"
export * from "./ModalAplicacao.vue?vue&type=script&lang=js"
import style0 from "./ModalAplicacao.vue?vue&type=style&index=0&id=2dbe5811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbe5811",
  null
  
)

export default component.exports